/**
 * The firm the signed-in person is working in — set once by main.ts after
 * sign-in (their membership, or the firm of an admin's support session).
 *
 * Read by the few places that must name the firm or build its links without
 * a round trip: client/contractor link builders, exports, the Settings
 * placeholder.
 */

import { publicOrigin } from '@/lib/host-branding';

export interface CurrentFirm {
  /** Null only if unknown; the material library's photo paths need it (0039). */
  id: string | null;
  name: string;
  slug: string | null;
}

let current: CurrentFirm | null = null;

export function setCurrentFirm(firm: CurrentFirm | null): void {
  current = firm;
}

export function currentFirm(): CurrentFirm | null {
  return current;
}

/**
 * The base for a client or contractor link: the firm's own address when it
 * has a working one (Tonie's legacy host today; `<slug>.designstudiohq.com`
 * once vanity addresses are live), else wherever the designer is.
 */
export function portalLinkBase(origin: string = location.origin, pathname: string = location.pathname): string {
  const base = publicOrigin(current?.slug, origin);
  // Staying here keeps the path the app is served under; the firm's own
  // address serves the app at its root.
  return base === origin ? `${origin}${pathname}` : `${base}/`;
}
